module.exports = __webpack_public_path__ + "img/MAC160_R.b6bcf3ff.png";